import React from "react";
import { Tag, Tooltip } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";

// ── Colour palette ────────────────────────────────────────────
export const NAVY  = "#0B1F3A";
export const BLUE  = "#185FA5";
export const GREEN = "#3B6D11";
export const RED   = "#A32D2D";

// ── Format type badge colours ─────────────────────────────────
export const FORMAT_COLORS = {
  CSV_DELIMITED:  { bg: "#E6F4EA", text: "#1A6B1A" },
  PIPE_DELIMITED: { bg: "#FFF3CD", text: "#7A4A00" },
  IDX_RECORD:     { bg: "#E8F0FE", text: "#185FA5" },
  XML_NUGGET:     { bg: "#F3E8FE", text: "#6B21A8" },
  FIXED_WIDTH:    { bg: "#FEE8E8", text: "#A32D2D" },
};

// ── Column mapper transform options ──────────────────────────
export const TRANSFORMS = [
  { value: null,            label: "No transform"        },
  { value: "UPPERCASE",    label: "UPPERCASE"            },
  { value: "LOWERCASE",    label: "lowercase"            },
  { value: "TRIM",          label: "Trim whitespace"     },
  { value: "STRIP_ZEROS",   label: "Strip leading zeros" },
  { value: "REMOVE_COMMA",  label: "Remove commas"       },
];

// ── Wizard step definitions ───────────────────────────────────
export const FLOW_STEPS = [
  { title: "Source",   desc: "Upload data"    },
  { title: "Mapping",  desc: "Map fields"     },
  { title: "Validate", desc: "Pre-flight"     },
  { title: "Generate", desc: "Build & deliver"},
];

// ── History drawer column definitions ────────────────────────
export const HISTORY_COLUMNS = [
  { title: "System",   dataIndex: "system_name",   key: "system_name",   width: 130 },
  { title: "Template", dataIndex: "template_name", key: "template_name", width: 180 },
  {
    title: "File", dataIndex: "output_filename", key: "output_filename",
    render: (t) => <Tooltip title={t}><code style={{ fontSize: 11 }}>{t}</code></Tooltip>,
  },
  { title: "Rows",   dataIndex: "total_rows",   key: "total_rows",   width: 70  },
  {
    title: "Source", dataIndex: "source_type", key: "source_type", width: 110,
    render: (t) => <Tag style={{ fontSize: 10 }}>{t}</Tag>,
  },
  {
    title: "SFTP", dataIndex: "sftp_delivered", key: "sftp_delivered", width: 55,
    render: (v) => v ? <CheckCircleOutlined style={{ color: GREEN }} /> : "—",
  },
  {
    title: "Status", dataIndex: "status", key: "status", width: 90,
    render: (s) => (
      <Tag color={s === "COMPLETED" ? "success" : s === "PARTIAL" ? "warning" : "error"}>
        {s}
      </Tag>
    ),
  },
  {
    title: "Hash", dataIndex: "output_file_hash", key: "hash", width: 110,
    render: (h) => h ? <code style={{ fontSize: 10 }}>{h.slice(0, 10)}…</code> : "—",
  },
  {
    title: "Date", dataIndex: "generated_date", key: "generated_date", width: 130,
    render: (t) => <span style={{ fontSize: 11 }}>{t}</span>,
  },
];
